exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tabButtonComponent---1kib8 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 45px;\n  width: 111px;\n  font-family: poppins;\n  font-size: 16px;\n  font-weight: 500;\n  border: 1px solid #cfd2d4;\n  color: #444;\n  background-color: #fff;\n  outline: none;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  text-decoration: none !important; }\n  .tabButtonComponent---1kib8.highlight---IlreC {\n    border: 1px solid #959595;\n    background-color: #415667;\n    color: #fff; }\n", ""]);

// exports
exports.locals = {
	"tabButtonComponent": "tabButtonComponent---1kib8",
	"highlight": "highlight---IlreC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/tab-button/index.scss
// module id = 1198
// module chunks = 3